// extracted by mini-css-extract-plugin
export var divider = "_uk-0";
export var systemMessage = "_uk-1";